"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
Yup.addMethod(Yup.mixed, "defined", function(msg = "$value must be defined") {
  return this.test("defined", msg, value => value !== undefined);
});
exports.nodeSchema = Yup.object()
  .shape({
    id: Yup.string().required(),
    type: Yup.string().required(),
    // .oneOf(validNodeTypes), // todo throwing error in webapp test cases need to fix this.
    next: Yup.string().nullable(),
    previous: Yup.string().nullable(),
    inputs: Yup.object().required(),
    target: Yup.object().required()
  })
  .required();
exports.selectedResourceSchema = Yup.object()
  .shape({
    selectedResourceId: Yup.string().required(),
    // nodeRef:Yup.mixed().when("selectedResourceId" ,{
    //     is: "NONE",
    //     then: Yup.object(),
    //     otherwise: Yup.object().required("nodeRef is required for valid selectedResourceId"),
    //   }),
    path: Yup.string()
      // @ts-ignore
      .defined("path is required")
      .nullable(),
    label: Yup.string().required(),
    context: Yup.object()
      .shape({
        // @ts-ignore
        outputPath: Yup.string()
          // @ts-ignore
          .defined("outputpath is required")
          .nullable()
      })
      .required()
  })
  .required("selectedResource is required");
//# sourceMappingURL=IValidation.js.map
